import { ThemeValues } from '@siteground/styleguide';
import { SET_OPTIONS } from '../app-communication/actions/from-main-app';

const [defaultTheme] = ThemeValues;

const initialState = {
  theme: defaultTheme,
  isEasyReadActive: null,
  size: 'small',
  initial_question: '',
  ai_assistant_thread_id: ''
};

export const optionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPTIONS: {
      return {
        ...state,
        ...action.payload
      };
    }
    default:
      return state;
  }
};
